{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Valige üksus",
  "tableResizer": "Suuruse muutja"
}
